import { AxiosInstance } from 'axios';
import AuthUtils from '../utils/auth-utils';
import ApiResponseResult from '../models/api';
import { Logout } from '../../auth/actions';
import { ServerError } from '../utils/server-error-utils';

let store;

export const injectStore = (newStore) => {
  store = newStore;
};

export const applyAccessTokenInterceptor = (client: AxiosInstance) =>
  client.interceptors.request.use((config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${AuthUtils.getAccessToken()}`,
      },
    };
  });

export const applyAuthTokenInterceptor = (client: AxiosInstance) =>
  client.interceptors.request.use((config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${AuthUtils.getAuthToken()}`,
      },
    };
  });

export const applyTokenExpirationInterceptor = (client: AxiosInstance) =>
  client.interceptors.response.use((response) => {
    if (response?.data?.result === ApiResponseResult.Failure &&
      (response?.data?.meta?.error === ServerError.TokenHasExpired || response?.data?.error === ServerError.InvalidToken) &&
      response?.config?.url !== '/account/logout'
    ) {
      AuthUtils.setSessionHasExpired();
      AuthUtils.removeAccessToken();
      AuthUtils.removeAccessTokenExp();
      AuthUtils.removeAuthToken();
      store.dispatch(new Logout());
    }
    return response;
  });

// Appeases typescript
declare const window: any;

export const applyPendingRequestCountInterceptor = (client: AxiosInstance) => {
  window.pending_requests = 0;

  client.interceptors.request.use(config => {
    window.pending_requests += 1;
    return config;
  });

  client.interceptors.response.use(
    response => {
      window.pending_requests -= 1;
      return response;
    },
    error => {
      window.pending_requests -= 1;
      return Promise.reject(error);
    }
  );

  return client;
};
